import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import {
  Col,
  FormInputRadio,
  Row
} from 'camino-react'

const RadioSelectType = ({
  range,
  question,
  handleRadioSelect,
  unsubmittedResponses
}) => {
  const startValue = _.isNil(range) ? null : _.toNumber(_.head(range))
  // Lodash _.range method does not include the final value specified, so + 1
  // https://lodash.com/docs/4.17.15#range
  const endValue = _.isNil(range) ? null : _.toNumber(_.last(range)) + 1
  const rangeValues = _.isNil(range) ? null : _.range(startValue, endValue)
  const minRangeValue = _.isNil(range) ? null : _.toNumber(range[0])
  const maxRangeValue = _.isNil(range) ? null : _.toNumber(range[1])

  const getCurrentRadioValue = (questionId, answer) => {
    const foundQuestion = _.find(unsubmittedResponses, { questionId: questionId })

    return _.isNil(foundQuestion) ? false : foundQuestion.answer === answer
  }
  
  if (_.isNil(range)) {
    return (
      <Row>
        <Col>
          {_.map(question.answers, (answer, index) => (
            <FormInputRadio
              key={index}
              id={`singleselect_answers_${question.id}_${index}`}
              onValue={value => handleRadioSelect(value, answer, question)}
              value={getCurrentRadioValue(question.id, answer)}
            >
              {answer}
            </FormInputRadio>
          ))}
        </Col>
      </Row>
    )
  } else {
    return (
      <Row>
        <Col classExtra='d-flex justify-content-around p-4 align-items-end'>
          {_.map(rangeValues, rangeValue => (
              <FormInputRadio
                key={rangeValue}
                inline
                id={`range_answers_${question.id}_${rangeValue}`}
                onValue={value => handleRadioSelect(value, rangeValue, question)}
                value={getCurrentRadioValue(question.id, rangeValue)}
                lowestRangeValue={rangeValue === minRangeValue}
                highestRangeValue={rangeValue === maxRangeValue}
              >
                {rangeValue}
              </FormInputRadio>
          ))}
        </Col>
      </Row>
    )
  }
}

RadioSelectType.defaultProps = {
  range: null
}

export default RadioSelectType
